import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { threeDotsLoaderDriverFactory } from './ThreeDotsLoader.driver';
import { ThreeDotsLoader, ThreeDotsLoaderProps } from '.';

describe('ThreeDotsLoader', () => {
  const createDriver = createRendererWithUniDriver(
    threeDotsLoaderDriverFactory,
  );

  const bootstrap = (props: Partial<ThreeDotsLoaderProps> = {}) => {
    return createDriver(<ThreeDotsLoader {...props} />);
  };

  it('should render', async () => {
    const { driver } = bootstrap();
    expect(await driver.exists()).toBe(true);
  });
});
